const LAST_SEARCHES_PREFIX = "LastSearches";

export const LAST_SEARCHES_CLASSES = {
  header: `${LAST_SEARCHES_PREFIX}-header`,
  headerText: `${LAST_SEARCHES_PREFIX}-headerText`,
  element: `${LAST_SEARCHES_PREFIX}-element`,
};
